(function () {
  const order = ['START', 'OBJECT', 'TRANSITION', 'DECISION', 'EXIT'];
  const points = {
    START: { code: '01', name: 'Start', title: 'Nothing begins', what: 'Your child is awake, but horizontal or busy with something else. Time passes without an argument. This may be an activation problem rather than a compliance problem.', trap: 'Repeating the same full instruction louder. After two failed prompts, the instruction is no longer the useful unit.', script: '“Feet on the floor. That is the only job right now.”', move: 'Shrink the next action until it is easy to begin. Help physically after two prompts instead of adding a third.' },
    OBJECT: { code: '02', name: 'Object', title: 'Something is missing', what: 'A shoe, bottle or folder turns the household into a search party. It looks like irresponsibility in the moment, but the fast problem is usually storage.', trap: 'Starting a character conversation when the family has thirty seconds. Responsibility is a slow fix applied to a fast problem.', script: '“You put your bag on the hook last night. That is why we found it right away.”', move: 'Give every leaving object one named place by the door, and load it before bedtime.' },
    TRANSITION: { code: '03', name: 'Transition', title: 'Stopping is the problem', what: 'Your child began something absorbing and cannot feel the ending coming. The resistance is often about stopping, not about shoes or breakfast.', trap: 'A five-minute warning. Young children cannot reliably feel five minutes, so the ending can still arrive from nowhere.', script: '“Two more turns, then shoes. I will tell you when it is the last one.”', move: 'Anchor the warning to something visible: two turns, one page, the end of this song.' },
    DECISION: { code: '04', name: 'Decision', title: 'An open choice stalls it', what: 'Clothes, breakfast or the cup remain undecided. Every open choice becomes a place to negotiate when nobody has time to negotiate.', trap: 'Removing all choice. That can trade a short negotiation for a longer standoff.', script: '“Blue sweater or gray sweater. You pick.”', move: 'Offer two acceptable options, prepared in advance. If neither is chosen, calmly say that you will choose.' },
    EXIT: { code: '05', name: 'Exit', title: 'It collapses at the door', what: 'Most of the routine worked, then the coat, goodbye or last request brought tears. The final minutes carry the most pressure and the least patience.', trap: 'Adding explanations or bigger consequences while the clock keeps moving. Both raise the temperature.', script: '“The coat comes with us. On now, or in my bag and on outside. Which?”', move: 'Keep the boundary fixed and offer a choice about how, not whether.' }
  };
  const questions = [
    { title: 'Where did the first delay happen?', help: 'The first one, not the loudest one. The argument at the door may be the fourth event in the chain.', options: [
      ['Nothing got started', 'Awake, but horizontal or busy with something else.', { START: 4 }], ['Something was missing', 'A shoe, the bottle, the folder. The house searched.', { OBJECT: 4 }], ['They would not stop what they were doing', 'A game, a screen, a build on the floor.', { TRANSITION: 4 }], ['An open question stalled it', 'Which clothes, which breakfast, which cup.', { DECISION: 4 }], ['Everything worked until the door', 'The coat, the tears, the last-minute request.', { EXIT: 4 }]
    ] },
    { title: 'Was your child refusing, or not starting?', help: 'They look identical from the hallway and need opposite responses.', options: [
      ['Refusing. An active no', 'They said no and meant it.', { EXIT: 2, TRANSITION: 1 }], ['Not starting. The request evaporated', 'No argument. Nothing happened either.', { START: 3 }], ['Both, at different moments', 'It shifted as the morning went on.', { START: 1, EXIT: 1, TRANSITION: 1 }], ['Neither. They were upset, not resistant', 'Tears rather than a no.', { EXIT: 3 }]
    ] },
    { title: 'How many separate instructions did you give before it went wrong?', help: 'Instructions stacked on top of each other cancel each other out.', options: [['One or two', '', {}], ['Three to five', '', { START: 1, TRANSITION: 1 }], ['More than I want to admit', '', { START: 2, TRANSITION: 1 }], ['I genuinely lost count', '', { START: 2, TRANSITION: 2 }]] },
    { title: 'What decision was still open that morning?', help: 'Every open decision is a place the morning can stop.', options: [['What to wear', '', { DECISION: 3 }], ['What to eat', '', { DECISION: 3 }], ['Whether a screen was allowed', '', { TRANSITION: 2, DECISION: 1 }], ['Who does what between the adults', '', { DECISION: 1, EXIT: 2 }], ['Nothing. It was settled the night before', '', { OBJECT: 1 }]] },
    { title: 'What time did you actually leave?', help: 'Use the real number. Being on time can still cost too much.', options: [['On time, but it cost everyone', 'Nobody was late. Everybody arrived wrung out.', {}], ['Under ten minutes late', 'The plan fits. The execution slipped.', {}], ['Ten to twenty-five minutes late', 'Both a plan problem and a friction problem.', {}], ['More than twenty-five minutes late', 'The morning as designed does not fit.', {}]] },
    { title: 'What state were you in when it started?', help: 'Not as blame. As data. The useful fix is structural rather than moral.', options: [['Calm, and ahead of schedule', '', {}], ['Already behind before anyone woke up', '', { EXIT: 1, START: 1 }], ['Doing three things at once', '', { OBJECT: 2, START: 1 }], ['Already frustrated from yesterday', '', { EXIT: 2 }]] }
  ];
  const answerCodes = [
    ['start', 'object', 'transition', 'decision', 'exit'],
    ['refusing', 'not-starting', 'both', 'upset'],
    ['one-two', 'three-five', 'six-plus', 'lost-count'],
    ['clothes', 'food', 'screen', 'adult-roles', 'settled'],
    ['on-time-cost', 'late-under-ten', 'late-ten-twenty-five', 'late-over-twenty-five'],
    ['calm', 'already-behind', 'multitasking', 'carryover-frustration']
  ];
  const storageKey = 'doorwayQuizResultV1';
  let latestQuizPayload = null;

  function analyticsContext() {
    const allowed = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'];
    const context = { event_version: 1, page_path: window.location.pathname };
    const params = new URLSearchParams(window.location.search);
    allowed.forEach(function (key) {
      const value = params.get(key);
      if (value) context[key] = value.trim().slice(0, 100);
    });
    return context;
  }

  function publishDoorwayEvent(name, data) {
    if (!window.DoorwayAnalytics || typeof window.DoorwayAnalytics.publish !== 'function') return;
    const payload = Object.assign({}, analyticsContext(), data || {});
    window.DoorwayAnalytics.publish('doorway:' + name, payload);
  }

  function cartUpdateUrl() {
    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    return root + 'cart/update.js';
  }

  function setPurchaseMetadata(payload) {
    latestQuizPayload = payload;
    document.querySelectorAll('[data-doorway-buy-form]').forEach(function (form) {
      form.dataset.doorwayMetadataReady = 'false';
      form.querySelectorAll('[data-doorway-property]').forEach(function (input) {
        const key = input.dataset.doorwayProperty;
        input.value = payload[key] || '';
        input.disabled = !input.value;
      });
    });
  }

  function clearPurchaseMetadata() {
    latestQuizPayload = null;
    try { window.sessionStorage.removeItem(storageKey); } catch (error) { /* Session storage is an optional convenience. */ }
    document.querySelectorAll('[data-doorway-buy-form]').forEach(function (form) {
      form.dataset.doorwayMetadataReady = 'true';
      form.querySelectorAll('[data-doorway-property]').forEach(function (input) {
        input.value = '';
        input.disabled = true;
      });
    });
  }

  function saveCartAttributes(payload) {
    setPurchaseMetadata(payload);
    try { window.sessionStorage.setItem(storageKey, JSON.stringify(payload)); } catch (error) { /* Session storage is an optional convenience. */ }
    return window.fetch(cartUpdateUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        attributes: {
          'Doorway break point': payload.breakpoint,
          'Doorway quiz answers': payload.answers,
          'Doorway quiz scores': payload.scores,
          'Doorway quiz version': payload.version
        }
      })
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart attributes could not be saved.');
      document.querySelectorAll('[data-doorway-buy-form]').forEach(function (form) { form.dataset.doorwayMetadataReady = 'true'; });
      return response.json();
    });
  }

  function clearCartAttributes() {
    clearPurchaseMetadata();
    return window.fetch(cartUpdateUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        attributes: {
          'Doorway break point': '',
          'Doorway quiz answers': '',
          'Doorway quiz scores': '',
          'Doorway quiz version': ''
        }
      })
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart attributes could not be cleared.');
      return response.json();
    });
  }

  try {
    const storedPayload = JSON.parse(window.sessionStorage.getItem(storageKey));
    if (storedPayload && storedPayload.version === '1' && storedPayload.breakpoint) setPurchaseMetadata(storedPayload);
  } catch (error) { /* Ignore unavailable or malformed session storage. */ }

  document.querySelectorAll('[data-doorway-quiz]').forEach(function (quiz) {
    const content = quiz.querySelector('[data-quiz-content]');
    const label = quiz.querySelector('[data-quiz-label]');
    const count = quiz.querySelector('[data-quiz-count]');
    const progress = quiz.querySelector('[data-quiz-progress]');
    let answers = [];
    let attempt = 0;

    function scores() {
      const total = { START: 0, OBJECT: 0, TRANSITION: 0, DECISION: 0, EXIT: 0 };
      answers.forEach(function (choice, i) { const weights = questions[i].options[choice][2]; order.forEach(function (key) { total[key] += weights[key] || 0; }); });
      return total;
    }
    function renderQuestion() {
      const index = answers.length;
      const q = questions[index];
      label.textContent = 'Question ' + (index + 1);
      count.textContent = String(index + 1).padStart(2, '0') + ' / 06';
      progress.style.width = ((index + 1) / questions.length * 100) + '%';
      content.innerHTML = '<h3>' + q.title + '</h3><p class="dw-quiz-help">' + q.help + '</p><div class="dw-options">' + q.options.map(function (opt, i) { return '<button class="dw-option" type="button" data-choice="' + i + '"><span><b>' + opt[0] + '</b>' + (opt[1] ? '<small>' + opt[1] + '</small>' : '') + '</span><span aria-hidden="true">→</span></button>'; }).join('') + '</div>' + (index ? '<button class="dw-back" type="button">← Back</button>' : '');
      content.querySelectorAll('[data-choice]').forEach(function (button) { button.addEventListener('click', function () { answers.push(Number(button.dataset.choice)); answers.length === questions.length ? renderResult() : renderQuestion(); }); });
      const back = content.querySelector('.dw-back'); if (back) back.addEventListener('click', function () { answers.pop(); renderQuestion(); });
    }
    function renderResult() {
      const total = scores();
      const winner = order.reduce(function (best, key) { return total[key] > total[best] ? key : best; }, 'START');
      const p = points[winner];
      const payload = {
        version: '1',
        breakpoint: winner,
        answers: answers.map(function (choice, index) { return 'q' + (index + 1) + ':' + answerCodes[index][choice]; }).join('|'),
        scores: order.map(function (key) { return key.toLowerCase() + ':' + total[key]; }).join('|')
      };
      label.textContent = 'Your first break point'; count.textContent = '06 / 06'; progress.style.width = '100%';
      content.innerHTML = '<p class="dw-result-chip">' + p.code + ' · ' + p.name + '</p><h3>' + p.title + '</h3><p class="dw-result-summary">' + p.what + '</p><div class="dw-result-grid"><div><b>The trap</b><span>' + p.trap + '</span></div><div><b>Say this</b><span class="dw-script">' + p.script + '</span></div><div><b>Try tomorrow</b><span>' + p.move + '</span></div></div><div class="dw-result-actions"><a class="dw-button dw-dark" href="#book" data-doorway-track="result_method">See the complete method <span>↓</span></a><button class="dw-retake" type="button">Retake</button></div><p class="dw-quiz-foot" data-quiz-storage aria-live="polite">Saving your result to this Shopify cart. If you buy, it will be attached to the order.</p>';
      publishDoorwayEvent('quiz_complete', { quiz_version: 1, question_count: questions.length, attempt: attempt });
      publishDoorwayEvent('result_view', { quiz_version: 1, attempt: attempt });
      const storageStatus = content.querySelector('[data-quiz-storage]');
      saveCartAttributes(payload).then(function () {
        storageStatus.textContent = 'Saved to this Shopify cart. If you buy, your result and answer categories will be attached to the order.';
      }).catch(function () {
        storageStatus.textContent = 'Your result is saved in this browser. The buy button will retry attaching it to the Shopify cart.';
      });
      content.querySelector('.dw-retake').addEventListener('click', function () {
        answers = [];
        attempt += 1;
        clearCartAttributes().catch(function () { return null; });
        publishDoorwayEvent('quiz_start', { quiz_version: 1, question_count: questions.length, attempt: attempt, source: 'retake' });
        renderQuestion();
      });
    }
    const start = quiz.querySelector('[data-quiz-start]'); if (start) start.addEventListener('click', function () {
      attempt += 1;
      publishDoorwayEvent('quiz_start', { quiz_version: 1, question_count: questions.length, attempt: attempt, source: 'initial' });
      renderQuestion();
    });
  });

  if (document.querySelector('[data-doorway-quiz]')) publishDoorwayEvent('landing_view');
  document.addEventListener('click', function (event) {
    const target = event.target.closest ? event.target.closest('[data-doorway-track]') : null;
    if (!target) return;
    publishDoorwayEvent('primary_cta', { cta_id: target.dataset.doorwayTrack });
  });

  const lightbox = document.querySelector('[data-lightbox]');
  function openLightbox(src, label) {
    if (!lightbox) return;
    const image = lightbox.querySelector('[data-lightbox-image]');
    const caption = lightbox.querySelector('[data-lightbox-caption]');
    image.src = src;
    image.alt = label;
    caption.textContent = label;
    lightbox.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  if (lightbox) {
    document.querySelectorAll('[data-page-src]').forEach(function (page) {
      page.addEventListener('click', function () { openLightbox(page.dataset.pageSrc, page.dataset.pageLabel); });
    });
    function close() { lightbox.hidden = true; document.body.style.overflow = ''; }
    lightbox.querySelector('[data-lightbox-close]').addEventListener('click', close);
    lightbox.addEventListener('click', function (event) { if (event.target === lightbox) close(); });
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && !lightbox.hidden) close(); });
  }

  document.querySelectorAll('[data-page-reader]').forEach(function (reader) {
    const image = reader.querySelector('[data-reader-image]');
    const number = reader.querySelector('[data-reader-number]');
    const caption = reader.querySelector('[data-reader-caption]');
    const tabs = Array.from(reader.querySelectorAll('[data-reader-tab]'));
    let active = tabs[0];

    function select(tab) {
      active = tab;
      tabs.forEach(function (item) {
        item.classList.toggle('active', item === tab);
        item.setAttribute('aria-selected', item === tab ? 'true' : 'false');
      });
      image.src = tab.dataset.src;
      image.alt = 'Page ' + tab.dataset.page + ' from Where Mornings Break';
      number.textContent = 'Page ' + tab.dataset.page;
      caption.textContent = tab.dataset.caption;
    }

    tabs.forEach(function (tab) { tab.addEventListener('click', function () { select(tab); }); });
    reader.querySelectorAll('[data-reader-open]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (active) openLightbox(active.dataset.src, 'Page ' + active.dataset.page + ' · ' + active.dataset.caption);
      });
    });
    if (active) select(active);
  });
  document.querySelectorAll('[data-missing-product]').forEach(function (button) { button.addEventListener('click', function () { alert('This preview is ready. Select the ebook product in the theme editor to connect checkout.'); }); });
  document.querySelectorAll('[data-doorway-buy-form]').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      if (!latestQuizPayload || form.dataset.doorwayMetadataReady === 'true' || form.dataset.doorwaySubmitting === 'true') return;
      event.preventDefault();
      form.dataset.doorwaySubmitting = 'true';
      saveCartAttributes(latestQuizPayload).catch(function () { return null; }).then(function () {
        form.dataset.doorwayMetadataReady = 'true';
        if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.submit();
      });
    });
  });
})();
